import { createUseReorder } from '../shared/useReorder';

const isCard = (i: { typename?: string; __typename?: string; type?: string }) =>
  i?.typename === 'Card' || i?.__typename === 'Card' || i?.type === 'CARD';

export const useReorderCards = createUseReorder({
  dataAttribute: 'data-card-id',
  className: 'card-drag-active',
  ghostClassName: 'drag-card-ghost',
  styleId: 'card-drag-optimizations',
  filterFn: isCard
});
